export const Languages = Object.freeze({
    hy: 'hy',
    en: 'en',
})
export const NavDropdown = [
    {
        path:'/about',
        title:'header_item_about',
    },
    {
        path:'/news',
        title:'header_item_events',
    },
    {
        path:'/partners',
        title:'partners_menu_title',
    },
    {
        path:'/contact',
        title:'header_item_contact',
    },
]

export const PackageTypes = Object.freeze({
    Package: 'Package',
    Paid: 'Paid',
})
